import React from "react";

// Components
import AuthorCard, { Author } from "./AuthorCard";
import Card from "@material-ui/core/Card";
import TagList from "./TagList";
import Typography from "@material-ui/core/Typography";
import Img from "gatsby-image";

// Types
import { ChildImageSharp } from "../../helpers/types";

// Styles
import {
  createStyles,
  withStyles,
  WithStyles,
  Theme,
} from "@material-ui/core/styles";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      backgroundImage:
        "linear-gradient(rgb(255, 255, 255), rgb(245, 245, 250))",
      transition: "transform 0.2s ease-out 0s, box-shadow 0.2s ease-out 0s",

      "&:hover": {
        transform: "scale(1.03)",
      },
      height: "100%",

      borderRadius: 8,

      // Img -> section -> author
      display: "flex",
      flexDirection: "column",
    },
    img: {
      height: 200,
    },
    section: {
      padding: theme.spacing(1.5),
    },
    tagList: {
      marginBottom: theme.spacing(1.5),
    },
    body: {
      margin: `${theme.spacing(3)}px 0px`,
    },
    author: {
      marginTop: "auto",
      padding: theme.spacing(1.5),
    },
  });

export type PostCardInfo = {
  excerpt?: string;
  frontmatter: {
    cover: { childImageSharp: ChildImageSharp };
    path: string;
    title: string;
    date: string;
    author: Author;
    tags?: string[];
    description?: string;
  };
} & WithStyles<typeof styles>;

function PostCard({
  classes,
  frontmatter: { cover, author, title, tags, description },
  excerpt,
}: PostCardInfo) {
  return (
    <Card raised component="article" className={classes.root}>
      <Img fluid={cover.childImageSharp.fluid} className={classes.img} />
      <section className={classes.section}>
        {tags ? <TagList tags={tags} className={classes.tagList} /> : null}
        <Typography variant="h5">{title}</Typography>
        <Typography variant="body1" className={classes.body}>
          {description || excerpt}
        </Typography>
      </section>
      <AuthorCard className={classes.author} author={author} />
    </Card>
  );
}

export default withStyles(styles)(PostCard);
